import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import CanvasGraphqlReaderForm from '../forms/canvas-graphql-reader-form';
import { canvasGraphQLReaderValidationSchema } from '../schema/canvasGraphqlReader.js';

export default function CanvasGraphqlReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Canvas GraphQL Reader Node Details',
        altText: 'Canvas GraphQL Reader Node',
        defaultLabel: 'Canvas GraphQL Reader Node',
      }}
    >
      <CommonNode
        FormComponent={CanvasGraphqlReaderForm}
        schemaResolver={canvasGraphQLReaderValidationSchema}
      />
    </NodeProvider>
  );
}
